import {Axios} from '../../index'

export const Put = async <T>(endpoint: string, data: any): Promise<T> => {

  try {
    const response = await Axios.put<T>(endpoint, data)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}